/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Content_Ai_QuotaInputs */

const en_directory_submit_content_ai_quota = /** @type {(inputs: Directory_Submit_Content_Ai_QuotaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submission quota reached — manual fill is still available.`)
};

const zh_directory_submit_content_ai_quota = /** @type {(inputs: Directory_Submit_Content_Ai_QuotaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交额度已用完 — 仍可手动填写。`)
};

/**
* | output |
* | --- |
* | "Submission quota reached — manual fill is still available." |
*
* @param {Directory_Submit_Content_Ai_QuotaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_content_ai_quota = /** @type {((inputs?: Directory_Submit_Content_Ai_QuotaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Content_Ai_QuotaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_content_ai_quota(inputs)
	return zh_directory_submit_content_ai_quota(inputs)
});
export { directory_submit_content_ai_quota as "directory.submit.content.ai_quota" }